import { Marker } from '@react-google-maps/api';
import React from 'react';

export const MapMarker: React.FC<{
  indexVal: number;
  positionVal: google.maps.LatLng | google.maps.LatLngLiteral;
  clickHandler: () => void;
  labelVal?: string | google.maps.MarkerLabel | undefined;
  iconVal?: string | google.maps.Icon | google.maps.Symbol | undefined;
  clickable?: boolean;
  title?: string | undefined;
  ariaLabel?: string | undefined;
}> = ({ indexVal, positionVal, clickHandler, labelVal, iconVal, clickable = true, title, ariaLabel }) => {
  return (
    <div>
      <Marker
        key={indexVal}
        position={positionVal}
        onClick={clickHandler}
        label={labelVal}
        icon={iconVal}
        clickable={clickable}
        title={title}
        aria-label={ariaLabel}
      />
    </div>
  );
};
